import { Outlet } from 'react-router-dom';
import { NavBar, SiteFooter } from './ui-bits';
import DemoModal from './DemoModal';
import '../index.css';

/** Shared chrome for every page (homepage + directory). */
export default function RootLayout() {
  return (
    <div className="min-h-dvh bg-canvas">
      <NavBar />
      <Outlet />
      <SiteFooter />
      <DemoModal />
    </div>
  );
}
